import _isEmpty from 'underscore/cjs/isEmpty.js'

import { useUtmsStore } from './utms'

export const useHealthInsuranceStore = defineStore('health-insurance', {
  state: () => ({
    page: null,

    guides: {
      url: null,
      initialPage: ''
    },
    form: {},

    hospitalCovers: {},
    extraCovers: {},
    policyId: 0,
    premiumType: '',
    state: '',
    reference: '',
    tier: '',
    directDebit: '',
    loading: 0,
    ageBasedDiscount: 0,
    percentage: '',

    refineParams: {
      searchBy: '',
      responseType: 'min',
      'search[lifestage]': '',
      'search[state]': '',
      'search[income]': 'nil',
      'search[primary_age]': 1,
      'search[age_secondary]': 1,
      'search[age_primary]': 1,
      'search[hospital_benefit_level]': '',
      'search[extra_benefit_level]': '',
      'search[excess]': 500,
      'search[rebate_percentage]': 0.24608, // ??
      'search[premium_type]': 'monthly',
      'search[hospital_covers]': '',
      'search[extra_covers]': '',
      'search[co_payment]': 'all',
      'search[age_based_discount]': 1,
      filterCurrentFund: true,
      sort: 'price'
    },

    quotesData: {},
    activeRebates: []
  }),

  getters: {
    leadParams () {
      const form = this.form

      if (_isEmpty(form)) {
        return {}
      }

      const utmsStore = useUtmsStore()
      const formData = flattenObj(form, 1)

      const covers = (() => {
        if (!formData?.cover_type) {
          return {}
        }

        return getKey(formData.cover_type.toLowerCase().replace(/ /, '_'), {
          hospital_only: {
            hospital_level: 'silver plus',
            extra_level: 'nil'
          },
          extras_only: {
            hospital_level: 'nil',
            extra_level: 'low'
          },
          default: {
            hospital_level: 'silver plus',
            extra_level: 'low'
          }
        })
      })()

      let tempPostcode = {}
      if (typeof formData?.postcode === 'string') {
        tempPostcode = {
          postcode: formData?.postcode,
          state: formData?.state,
          suburb: formData?.suburb
        }
      } else if (typeof formData?.postcode === 'object') {
        tempPostcode = {
          ...formData?.postcode
        }
      }

      let tempPaymentFrequencyAmount = {}
      if (formData.hasOwnProperty('payment_frequency')) {
        tempPaymentFrequencyAmount = {
          payment_frequency: formData?.payment_frequency
        }
      }

      if (formData.hasOwnProperty('current_premium')) {
        tempPaymentFrequencyAmount = {
          ...tempPaymentFrequencyAmount,
          current_premium: parseInt((formData?.current_premium ?? '').replace(/[$,]/g, '')) || 0
        }
      }

      const obj = {
        ...covers,
        ...getName(formData?.full_name),
        age: formData?.age,
        age_secondary: formData?.age_secondary,
        birthdate: formData?.birthdate,
        partner_birthdate: formData?.partner_birthdate,
        cover_type: formData?.cover_type,
        email: formData?.email,
        extras_cover_list: joinArr(formData?.extras_cover_list),
        health_cover: joinArr(formData?.health_cover),
        health_fund: (formData?.health_fund?.value || formData?.health_fund) ?? 'not insured',
        hospital_cover_list: joinArr(formData?.hospital_cover_list),
        income: formData?.income,
        life_stage: formData?.life_stage,
        partner_health_fund: ['Couple', 'Family'].includes(formData.life_stage)
          ? (formData.partner_health_fund?.value || formData.partner_health_fund) ?? 'not insured'
          : '',
        phone: formData?.phone,
        ...tempPostcode,

        brand: 'CC',
        enquiry_source: 'cc_nbf',
        form_page: import.meta.client && window.location.href,
        landing_page: utmsStore.GET_UTMS_LANDING_PAGE,
        ...tempPaymentFrequencyAmount

      }

      return obj
    }
  },

  actions: {
    SET_STATE (data) {
      if (this.$state === undefined || data.value === undefined) {
        // eslint-disable-next-line no-console
        console.error('SET_STATE params[\'state\', \'value\'] are required')
      }

      this.$state[data.state] = data.value
    },

    getAvailableTime ({ state, vertical, limit, category }) {
      return useFetch('/api/callback/availability', {
        params: {
          state,
          vertical,
          limit,
          category
        }
      }).then(response => {
        const res = response?.data.value ?? {}

        if (!_isEmpty(res?.error)) {
          return {}
        }

        return res?.data ?? {}
      }).catch(error => {
        throw error
      })
    },

    async createLead (payload) {
      const utmsStore = useUtmsStore()

      const response = await useFetch('/api/lead/create', {
        method: 'post',
        body: {
          vertical: 'Health Insurance',
          ...utmsStore.utms,
          ...payload
        }
      }).then(res => {
        const temp = res?.data.value

        if (temp?.error) {
          throw temp?.error
        }

        const data = temp?.data

        return data?.lead_uuid ?? undefined
      }).catch(error => {
        throw error
      })

      return response
    },

    optInCall (payload) {
      return useFetch('/api/health-insurance/optin', {
        method: 'post',
        body: {
          ...payload
        }
      }).then(response => {
        const res = response?.data.value ?? {}

        if (!_isEmpty(res?.error)) {
          return {}
        }

        return res?.data ?? {}
      }).catch(error => {
        throw error
      })
    }
  },

  persist: {
    storage: piniaPluginPersistedstate.sessionStorage()
  }
})
